export enum AppearanceModifier {
    Normal = 0,
    Heroic = 1,
    Mythic = 3,
    LookingForRaid = 4,

    WodCraftedT1 = 6,
    WodCraftedT2 = 7,
    WodCraftedT3 = 8,
}
